import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ChevronUp = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.3626 16.0025C19.2026 16.0025 19.0426 15.9425 18.9126 15.8325L12.0026 9.4625L5.09257 15.8325C4.84257 16.0625 4.43257 16.0625 4.18257 15.8225C3.93257 15.5825 3.94257 15.2025 4.19257 14.9625L11.5526 8.1725C11.8026 7.9425 12.1926 7.9425 12.4426 8.1725L19.8026 14.9525C20.0526 15.1825 20.0626 15.5725 19.8126 15.8125C19.6826 15.9325 19.5226 15.9925 19.3526 15.9925L19.3626 16.0025Z" />
  </svg>
)

export default withDefaultStyles(ChevronUp)
